import { useCallback, useEffect } from "react";
import { dataSyncEmitter } from "@/modules/events/emitter";
import { useEventFilters } from "viewer/store/eventFilters";

export default function useAppSync() {
  const onDeviceRemove = useCallback((removedDevice: StoreDevice) => {
    const { role, objectId } = removedDevice;
    if (role === "camera") useEventFilters.getState().removeCameraFilter(objectId);
  }, []);

  useEffect(() => {
    const unsub = dataSyncEmitter.on("device-removed", onDeviceRemove);
    return () => {
      unsub();
    };
  }, [onDeviceRemove]);
}
